export function setupNewsFilter() {
    const newsFilter = event => {
        const element = event.target;
        const filterType = element.getAttribute('data-filter');
        const filterValue = [];

        // Get values of the checked filters
        newsFilters.forEach(filter => {
            if (filter.getAttribute('data-filter') === filterType && filter.checked && filter.value !== '') {
                filterValue.push(filter.value);
            }
        });

        // Only show matching items
        newsItems.forEach(item => {
            let itemInclude = false;

            if (filterValue.length === 0 || item.getAttribute(`data-${filterType}`).indexOf(filterValue[0]) != -1) {
                itemInclude = true;
            }
            if (itemInclude) {
                item.classList.remove(`js-hidden-${filterType}`);
            } else {
                item.classList.add(`js-hidden-${filterType}`);
            }
        });

        if (newsList) {
            if (filterValue.length !== 0) {
                newsList.classList.add('js-filtered');
            } else {
                newsList.classList.remove('js-filtered');
            }
        }
    };

    const newsList = document.querySelector('.news-overview .overview__list');
    const newsItems = document.querySelectorAll('.news-overview .overview__item');
    const newsFilters = document.querySelectorAll('[data-action="news-filter"]');

    newsFilters.forEach(filter => {
        filter.addEventListener('change', newsFilter);
    });
}